import type { PropsWithChildren } from "react";
import {
  AirPriceDropSelectors,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Header, BackButton, MobileFloatingButton } from "@hopper-b2b/ui";
import { useEnablePriceDropProtection } from "@hopper-b2b/utilities";
import { Typography } from "@material-ui/core";

import "./styles.scss";
import { FlightPriceDropProtectionBanner } from "../../../../../../components/Slots";

interface ReviewComponentProps extends PropsWithChildren {
  handleGoBack: () => void;
  onBookFlight: () => void;
  priceBreakdowndropdown?: JSX.Element;
  header?: boolean;
  headerTitle?: string;
  ctaLabel?: string;
}

export const ReviewLayout = (props: ReviewComponentProps) => {
  const {
    handleGoBack,
    onBookFlight,
    priceBreakdowndropdown,
    header = true,
    headerTitle,
    ctaLabel,
    children,
  } = props;

  const { t } = useI18nContext();

  const priceDropProtectionEnabled = useEnablePriceDropProtection();
  const isPDPEligible = useSelector(
    AirPriceDropSelectors.getPriceDropEligibility
  );

  const content = (
    <>
      {header ? (
        <div className="title-summary-container">
          <Typography variant="h6" className="title">
            {t("tripReview")}
          </Typography>
          <Typography variant="body1" className="subtitle">
            {t("tripReviewSubtitle")}
          </Typography>
        </div>
      ) : null}
      {children}
      <div className={"flight-book-mobile-button-container"}>
        <MobileFloatingButton
          className="flight-book-mobile-button"
          onClick={onBookFlight}
          wrapperClassName="b2b"
          wide
          topContent={
            <FlightPriceDropProtectionBanner
              isEligible={priceDropProtectionEnabled && isPDPEligible}
              showMore
              inReview
              className="flight-checkout-review-pdp-banner"
            />
          }
        >
          {ctaLabel ? ctaLabel : t?.("confirmAndBook")}
        </MobileFloatingButton>
      </div>
    </>
  );
  return (
    <div
      className={"mobile-flight-book-workflow-root mobile-review-flight-book"}
    >
      <Header
        className="mobile-flight-book-workflow-header"
        left={
          <BackButton
            className="mobile-flight-book-header-go-back"
            onClick={handleGoBack}
          />
        }
        right={priceBreakdowndropdown}
        title={headerTitle}
        isMobile
        fullWidth
      />
      {content}
    </div>
  );
};
